export default "__VITE_ASSET__D$fqadHV__"